<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">MRR - Receita Mensal Recorrente</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <form class="ui small form" v-autocomplete-off @submit.prevent="search()">
        <div class="ui padded grid">
          <div class="ten wide column">
            <div class="ui required field">
              <label for="">Intervalo</label>
              <div class="inline fields">
                <div class="four wide field">
                  <label for="mrr-date-of-payment-from">De:</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="mrr-date-of-payment-from"
                    v-model="form.start_date"
                  />
                </div>
                <div class="four wide field">
                  <label for="mrr-date-of-payment-until">Até</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="mrr-date-of-payment-until"
                    v-model="form.end_date"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-show="loading" class="ui active loader"></div>
      <div v-show="!loading" class="ui padded grid">
        <div class="row">
          <div class="two wide column">
            <h2 class="ui header">
              {{ payments.length }}
              <div class="sub header">Total de pagamentos.</div>
            </h2>
            <h2 class="ui header">
              {{ contractCount }}
              <div class="sub header">Total de contratos.</div>
            </h2>
          </div>
          <div class="fourteen wide column">
            <div class="ui fluid card">
              <div class="content">
                <div class="header">Desempenho Mensal</div>
              </div>
              <div class="content">
                <GrowthChart ref="growthChart" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="two wide column"></div>
          <div class="seven wide column">
            <div class="ui fluid card">
              <div class="content">
                <div class="header">Por Plano</div>
              </div>
              <div class="content">
                <PlanChart ref="planChart" />
              </div>
            </div>
          </div>
          <div class="seven wide column">
            <div class="ui fluid card">
              <div class="content">
                <div class="header">Por Convênio</div>
              </div>
              <div class="content">
                <CovenantChart ref="covenantChart" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="two wide column"></div>
          <div class="fourteen wide column">
            <div class="ui fluid card">
              <div class="content">
                <div class="header">Contratos</div>
              </div>
              <div class="overflow content">
                <ContractsList ref="contractList" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>
<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import GrowthChart from './widgets/growth_chart';
import PlanChart from './widgets/plan_chart';
import CovenantChart from './widgets/covenant_chart';
import ContractsList from './widgets/contracts';
import { uniqBy } from 'lodash';

export default {
  name: 'MRR',
  components: {
    Breadcrumb,
    PageLayout,
    GrowthChart,
    PlanChart,
    ContractsList,
    CovenantChart
  },

  data() {
    return {
      loading: false,
      payments: [],
      form: {
        start_date: this.$moment()
          .endOf('month')
          .subtract(12, 'months')
          .format('DD/MM/YYYY'),
        end_date: this.$moment().endOf('month').format('DD/MM/YYYY')
      }
    };
  },

  computed: {
    contractCount() {
      return uniqBy(this.payments, 'contract_id').length;
    }
  },

  mounted() {
    this.search();
  },

  methods: {
    _updateGrowthReport() {
      this.$refs.growthChart.mountChart(this.payments);
    },

    search() {
      // Validates
      const dateFormat = 'DD/MM/YYYY';
      const startDate = this.$moment(this.form.start_date, dateFormat);
      const endDate = this.$moment(this.form.end_date, dateFormat);

      if (!startDate.isValid() || !endDate.isValid()) {
        this.$toast.show('Data inválida', 'error');
        return;
      }

      const monthsInterval = endDate.diff(startDate, 'months', true);
      if (monthsInterval > 12) {
        this.$toast.show('Intervalo não pode ser superior a um ano', 'error');
        return;
      }

      this.loading = true;
      const query = {
        q: {
          // date_of_payment_gteq: this.form.start_date,
          // date_of_payment_lteq: this.form.end_date
          date_of_payment_gteq: this.$moment(this.form.start_date, 'DD/MM/YYYY')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm'),
          date_of_payment_lteq: this.$moment(this.form.end_date, 'DD/MM/YYYY')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm')
        }
      };

      Api.payments
        .search(query)
        .then(response => {
          this.payments = response.data.payments;

          this.$refs.growthChart.mountChart(this.payments);
          this.$refs.planChart.mountChart(this.payments);
          this.$refs.contractList.setContracts(this.payments);
          this.$refs.covenantChart.mountChart(this.payments);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="css" scoped>
.overflow {
  overflow-y: scroll;
  height: 380px;
}
</style>
